export const translations = {
  " import cen": "импорт цен",
  "< Wróć": "< Назад",
  "Akcje": "акции",
  "Aktualizuj stany": "Обновить состояния",
  "Aktywność": "деятельность",
  "Aktywny": "активный",
  "Aktywny do": "Активен для",
  "Aktywowany": "активированный",
  "Anuluj": "отменить",
  "Autor": "автор",
  "Baner...": "Баннер ...",
  "Banery": "баннеры",
  "Biodra": "поясница",
  "Biust": "бюст",
  "Brak historii zamówień": "Нет истории заказов",
  "Brak zdjęcia": "Нет изображения",
  "Cancel": "отменить",
  "Cena": "цена",
  "Cena do": "Цена до",
  "Cena docelowa": "Целевая цена",
  "Cena od": "Цена от",
  "Cena przed obniżką": "Цена перед скидкой",
  "Cena przekreślona": "Цена вычеркнута",
  "Cena przekreślona do": "Цена перешла на",
  "Cena przekreślona od": "Цена, пересеченная с",
  "Cena sprzedaży": "Цена продажи",
  "Cena sprzedaży do": "Цена продажи до",
  "Cena sprzedaży od": "Цена продажи от",
  "Cena wyświetlana": "Показать цены",
  "Cena zakupu": "Цена покупки",
  "Cena zakupu do": "Цена покупки",
  "Cena zakupu netto": "Чистая цена покупки",
  "Cena zakupu od": "Покупная цена от",
  "Ceny produktu": "Цены на продукцию",
  "Czas utworzenia": "Время создания",
  "Czy na pewno chcesz usunąć stronę?": "Вы действительно хотите удалить страницу?",
  "Dane do wysyłki": "Данные для доставки",
  "Dane kontaktowe": "Контактная информация",
  "Data": "дата",
  "Data aktywacji": "Дата активации",
  "Data utworzenia": "Дата создания",
  "Do daty utworzenia": "До даты создания",
  "Do sztuk": "Куски",
  "Dodaj": "добавлять",
  "Dodaj efekt": "Добавить эффект",
  "Dodaj główną kategorię": "Добавить категорию",
  "Dodaj kategorię": "Добавить категорию",
  "Dodaj kupon": "Добавить купон",
  "Dodaj modelkę": "Добавить модель",
  "Dodaj nową modelkę": "Добавить новую модель",
  "Dodaj opinię": "Добавить отзыв",
  "Dodaj produkt": "Добавить продукт",
  "Dodaj stronę": "Добавить страницу",
  "Dodaj warunki": "Добавить условия",
  "Dostawa": "доставка",
  "Dostępne": "доступный",
  "Dostępność w przyszłości": "Доступность в будущем",
  "Dzieci": "дети",
  "Dzisiejsza": "сегодня",
  "EAN": "EAN",
  "ENTER": "ENTER",
  "Edytuj": "редактировать",
  "Edytuj modelkę": "Редактировать модель",
  "Edytuj opinię": "Редактировать отзыв",
  "Edytuj wiele produktów": "Редактирование многих продуктов",
  "Eksportuj ceny produktów": "Цены на экспортные товары",
  "Element skopiowany do schowka": "Элемент, скопированный в буфер обмена",
  "Followersów": "послідовник",
  "Forma wysyłki": "Форма доставки",
  "Gdzie ma przejść po kliknięciu": "Куда пойти после нажатия",
  "Grupa produktów": "Группа продуктов",
  "Historia": "история",
  "Historia (0)": "История (0)",
  "Historia (1)": "История (1)",
  "Historia sprzedaży": "История продаж",
  "Historia zamówień": "История заказов",
  "ID": "ID",
  "ID opinii": "ID отзыва",
  "Ilość": "номер",
  "Ilość na stanie": "Количество в наличии",
  "Ilość postów": "Количество сообщений",
  "Imię": "имя",
  "Importuj ceny": "Цены на импорт",
  "Importuj dane z born2be": "Импорт данных из born2be",
  "Indywidualny numer konta do wpłat": "Индивидуальный номер счета для вкладов",
  "Informacje o opinii": "Информация о мнении",
  "Instagram": "Instagram",
  "Język": "язык",
  "Język panelu": "Язык панели",
  "Język treści" : "Мова вмісту",
  "Język dynamicznych treści," : "Мова динамічного вмісту",
  "Język tekstów statycznych": "Мова статичних текстів",
  "Kategoria": "категория",
  "Kategorie": "категории",
  "Kliknij, aby anulować edycję parametrów i modelek": "Нажмите, чтобы отменить параметры и модели редактирования",
  "Kliknij, aby edytować kategorie": "Нажмите, чтобы изменить категории",
  "Kliknij, aby edytować parametry i modelki": "Нажмите, чтобы редактировать параметры и модели",
  "Kliknij, aby edytować zdjęcia": "Нажмите, чтобы редактировать фотографии",
  "Kobiety": "женщины",
  "Kod": "код",
  "Kod Package EAN": "Код пакета EAN",
  "Kod Polski": "Польский код",
  "Kod celny": "Таможенный код",
  "Kod chiński": "Китайский код",
  "Kod polski": "Польский код",
  "Kod produktu": "Код продукта",
  "Kody chińskie": "Китайские коды",
  "Kolor": "цвет",
  "Komfortu": "комфорт",
  "Koszty wysyłki": "Стоимость доставки",
  "Kup mniejsze": "Купить меньше",
  "Kup większe": "Купить больше",
  "Kupony": "купоны",
  "Kupony - dodaj": "Купоны - добавить",
  "Lato": "лето",
  "Liczba mieszkańców": "Количество жителей",
  "Liczba postów 12": "Количество сообщений 12",
  "Liczba postów 24": "Количество сообщений 24",
  "Liczba postów 36": "Количество должностей 36",
  "Liczba postów 48": "Количество сообщений 48",
  "Liczba postów 60": "Количество должностей 60",
  "Liczba znaków": "Количество символов",
  "Lista kategorii": "Список категорий",
  "Lista kuponów": "Список купонов",
  "Lista postów": "Список сообщений",
  "Lista produktów": "Список продуктов",
  "Lista stron": "Список страниц",
  "Losuj": "случайный",
  "Marketing": "маркетинг",
  "Max Date": "Макс. Дата",
  "Menu": "меню",
  "Meta keywords": "Мета-ключові слова",
  "Meta description": "Мета опис",
  "Miasto": "город",
  "Min Date": "Мин. Дата",
  "Modelki": "модели",
  "Models": "модели",
  "Męski": "мужчина",
  "Męzczyzni": "люди",
  "Mężczyzn": "люди",
  'Można łączyć':"Можна об'єднати",
  "Następny": "следующий",
  "Nazwa": "имя",
  "Nazwa pojedyncza": "Одно имя",
  "Nazwa produktu": "Название продукта",
  "Nazwa użytkownika": "имя пользователя",
  "Nazwa wewnętrzna": "Внутреннее имя",
  "Nie można łączyć": "Нельзя комбинировать",
  "Nieaktywny": "неактивный",
  "Niedostępne": "Нет в наличии",
  "Nieunikalny": "неуникальным",
  "Niezaakceptowane": "Не принимаются",
  "Niezaakceptowany": "неодобрение",
  "Nijaki": "бесполый",
  "Nijaki mnogi": "Многочисленные многочисленные",
  "Notatki": "примечания",
  "Numer strony": "Номер страницы",
  "O autorze": "Об авторе",
  "OK": "хорошо",
  "Obniżenie ceny o %": "Снижение цены на%",
  "Obniżka obecna (%)": "Снижение тока (%)",
  "Ocena": "оценка",
  "Ocena komfortu": "Комфорт",
  "Ocena stylu": "Рейтинг стилей",
  "Od daty utworzenia": "С даты создания",
  'Od najmniejszej' : "Від найменшого",
  "Od największej": "Из крупнейших",
  "Od sztuk": "Из частей",
  "Odśwież cache": "Обновить кеш",
  "Odśwież linki": "Обновить ссылки",
  "Ogólna": "все",
  "Opinie": "отзывы",
  "Opis kategorii": "Описание категории",
  "Opis meta": "Мета-описание",
  "Opis produktu": "Описание продукта",
  "Otwórz": "открытый",
  "Otwórz wyszukiwarkę": "Откройте поисковую систему",
  "Package EAN (zablokowane)": "Пакет EAN (заблокирован)",
  "Parametry": "параметры",
  "Pełna nazwa": "Полное имя",
  "Pobierz raport cen produktów": "Загрузите отчет о цене продукта",
  "Podgląd": "предварительный просмотр",
  "Podstawowe info": "Основная информация",
  "Poprzedni": "предыдущий",
  "Pora roku": "сезон",
  "Połącz w grupę": "Объединение в группу",
  "Producent": "производитель",
  "Produkt": "продукт",
  "Produkty": "продукты",
  "(produktów, kategorii itp)":"(продукти, категорії тощо)",
  "Przecena do ( % )": "Продажа до (%)",
  "Przecena od ( % )": "Продажа от (%)",
  "Przejdź do sklepu": "Перейти в магазин",
  "Przenieś niżej": "Перемещение ниже",
  "Przenieś wyżej": "Переместить выше",
  "Przypisz": "приписывать",
  "Płatność": "оплата",
  "Razem": "разом",
  "Raporty": "отчеты",
  "Raporty cen": "Цены",
  "Rodzaj nazwy": "Название имени",
  "Rodzaj przekierowania": "Тип перенаправления",
  'Rozmiar' : 'Розмір',
  "Rozmiar obuwia": "Размер обуви",
  "Rozmiarówka": "Таблица размеров",
  "Sortowanie": "сортировка",
  'Stan aktywacji':"Статус активації",
  "Status": "статус",
  "Strony statyczne": "Статические страницы",
  "Strony statyczne - edycja.":"Статические страницы - видання.",
  "Strony statyczne - nowa.":"Статические страницы - новий.",
  "Stylu": "стиль",
  "Submit": "представить",
  "Suma": "сумма",
  "Szablon": "шаблон",
  "Szczegóły": "детали",
  "Szczegóły zamówienia": "Подробная информация о заказе",
  "Szukaj kategorii...": "Поиск по категориям ...",
  "Słowa kluczowe": "Ключевые слова",
  "Słowo kluczowe": "Ключевое слово",
  "% przeceny": "% Продажи",
  "Minimalny % przeceny": "Минимальная скидка %",
  "Maksymalny % przeceny": "Максимальная скидка %",
  "Dodaj warunki wielorabatowe": "Добавить условия мультискидки",
  "Tag": "тег",
  "Talia": "талия",
  "Total": "общий",
  "Treść": "содержание",
  "Treść opinii": "Содержание мнения",
  "Trwa ładowanie": "загрузка",
  "Typ": "тип",
  "Typ baneru": "Тип баннера",
  "Typowa": "типичный",
  "Tytuł": "название",
  "Tytuł linku": "Название ссылки",
  "Tytuł produktu": "Название продукта",
  "Typ strony":"Тип сторінки",
  'Unikalny': 'Унікальний',
  "Upload": "загружать",
  "Ustaw dzisiejszą": "Установите сегодняшнюю",
  "Usuń": "удалять",
  "Usuń modelkę": "Удалить модель",
  "Uwaga": "предосторожность",
  "Vices status": "Vices статус",
  "Voucher": "ваучер",
  "Wartość": "значение",
  "Wartość efektu": "Значение эффекта",
  "Wartość produktów": "Стоимость продуктов",
  "Ważny do": "Действительно для",
  "Ważny od": "Действительно с",
  "Wgrywanie zdjęć": "Загрузка фотографий",
  "Wiosna/Jesień": "Весна / осень",
  "Wpisz alt zdjęcia": "Введите альт-фотографию",
  "Wpisz kod celny": "Введите таможенный код",
  "Wpisz link": "Введите ссылку",
  "Wpisz nazwę": "Введите имя",
  "Wpisz nazwę baneru": "Введите имя баннера",
  "Wpisz nazwę pojedynczą": "Введите одно имя",
  "Wpisz nowy EAN": "Введите новый EAN",
  "Wpisz opis kategorii": "Введите описание категории",
  "Wpisz opis meta": "Введите описание мета",
  "Wpisz słowa kluczowe": "Введите ключевые слова",
  "Wprowadź ean": "Введите ean",
  "Wprowadź kod": "Введите код",
  "Wprowadź kody chińskie": "Введите китайские коды",
  "Wprowadź nazwę": "Введите имя",
  "Wprowadź nazwę produktu": "Введите название продукта",
  "Wprowadź nazwę tagu": "Введите имя тега",
  "Wprowadź nazwę użytkownika": "Введите имя пользователя",
  "Wprowadź tag": "Введите тег",
  "Wróć": "возвращение",
  "Wszystkie": "все",
  'Wybierz importowane pola':'Виберіть імпортовані поля',
  "Wybierz jedno z proponowanych słów kluczowych lub wpisz własne i naciśnij": "Выберите один из предложенных ключевых слов или введите свой собственный и нажмите",
  "Wybierz kategorie": "Выбрать категории",
  "Wybierz poniżej...": "Выберите ниже ...",
  "Wybierz...": "Выбрать ...",
  "Wybór danego zdjęcia spowoduje natychmiastowe jego wysłanie na nasz serwer! Prosimy upewnić się, czy wrzucany plik na pewno jest prawidłowy.": "Выбор данной фотографии сразу отправит ее на наш сервер! Убедитесь, что файл, который вы загружаете, является правильным.",
  "Wyczyść filtry": "Очистить фильтры",
  "Wyloguj się": "Выход из системы",
  "Wymiary": "размеры",
  "Wyszukaj": "поиск",
  "Wyszukaj po id opinii": "Поиск по обратной связи id",
  "Wyszukaj po imieniu": "Поиск по названию",
  "Wyszukaj po kodzie produktu": "Поиск по товарному коду",
  "Wyszukaj po mieście": "Поиск по городу",
  "Wzrost": "рост",
  "Zamknij": "близко ",
  "Zamknij wyszukiwarkę": "Закрыть поисковую систему",
  "Zamówienia": "заказы",
  "Zamówienie numer": "Номер заказа",
  "Zamówienie odrzucone": "Заказ отклонен",
  "Zamówiona ilość": "Количество заказа",
  "Zapisz": "Сохранить",
  "Zapisz zmiany": "Сохранить изменения",
  "Zatwierdź": "представить",
  "Zaznaczonych produktów": "Выбранные продукты",
  "Zdjęcia": "фотографии",
  "Zdjęcie mobile": "Мобильное фото",
  "Zdjęcie modelki": "Модельное фото",
  "Zdjęcie na desktop": "Фото на рабочий стол",
  "Zima": "зима",
  "Zmień": "изменение",
  "Zmień EAN": "Изменить EAN",
  "Zmień status": "Изменить статус",
  "Zmień wszędzie": "Изменение везде",
  "Zobacz": "вид",
  "shipSpeed": "shipSpeed",
  "ubrań": "одежда",
  "Żeński": "женщина",
  "Анастасія": "Анастасий",
  "Анна": "Анна",
  "Богуслава": "Богуслава",
  "Ева": "Ева",
  "Любовь": "Любовь",
  "Мирослава": "Мирослава",
  "Наталья": "Наталья",
  "Раиса": "Раиса",
  "Регіна": "Регіна",
  "Соломия": "Соломия",
  "Тетяна": "Тетяна",
  "Ярина": "Ярина"
};



// WEBPACK FOOTER //
// ./locales/ru_UA/translations.js